import apiClient from "./apiClient";

export const staffService = {
    /**
     * Create a new staff member (Vendor Staff or Vendorless Unit Admin Staff)
     * @param {Object} payload 
     */
    createStaff: async (payload) => {
        return apiClient.post('/staff-management/staff/CreateStaff', payload);
    },

    /**
     * Get active staff roles for a given site
     * @param {number|string} siteId 
     */
    getStaffRoles: async (siteId) => {
        return apiClient.get('/staff-management/staff/GetRoles', {
            params: { siteId }
        });
    },

    /**
     * Get staff list with filtering & pagination
     * @param {Object} params 
     */
    getStaff: async (params) => {
        return apiClient.get('/staff-management/staff/GetStaff', {
            params
        });
    },

    /**
     * Update existing staff member
     * @param {number|string} staffId
     * @param {Object} payload
     */
    updateStaff: async (staffId, payload) => {
        return apiClient.put(`/staff-management/staff/UpdateStaff?staffId=${staffId}`, payload);
    },

    /**
     * Allot or update duty shift for a staff member
     * @param {Object} payload
     */
    allotDuty: async (payload) => {
        return apiClient.post('/staff-management/staff/AllotDuty', payload);
    },

    /**
     * Update duty allotment for a staff member
     * @param {number|string} allotmentId
     * @param {Object} payload
     */
    updateAllotment: async (allotmentId, payload) => {
        return apiClient.post(`/staff-management/staff/UpdateAllotment?allotmentId=${allotmentId}`, payload);
    },

    /**
     * Upload identity document for an existing staff member
     * @param {Object} payload - { staffId, documentType, documentNumber, fileName, filePath, createdBy }
     */
    uploadStaffDocument: async (payload) => {
        return apiClient.post('/staff-management/staff/UploadDocument', payload);
    },

    /**
     * Get vendors for vendor selection dropdown
     * @param {Object} params 
     */
    getVendors: async (params) => {
        return apiClient.get('/vendor-management/vendor/GetVendors', {
            params
        });
    },

    /**
     * Get shifts for staff based on personTypeId (3 = staff)
     * @param {number|string} personTypeId 
     */
    getShifts: async (personTypeId = 3) => {
        return apiClient.get('/shift-master/GetShifts', {
            params: { personTypeId }
        });
    }
};

export default staffService;
